import type { EnvironmentSlug } from "../../../Environment";

interface YarnScriptSettings {
  environmentSlug: EnvironmentSlug | string;
}

export const ShopifyYarnScripts: Record<string, { generate: (appSettings: YarnScriptSettings) => string; description: string }> = {
  shopify: {
    description: "Default Shopify CLI command",
    generate: (_appSettings: YarnScriptSettings) => "shopify",
  },
  "shopify:config:use:development": {
    description: "Use the current development environment's Shopify app config",
    generate: (appSettings: YarnScriptSettings) => `shopify app config use shopify.app.${appSettings.environmentSlug}.toml`,
  },
  "shopify:config:use:production": {
    description: "Use the production environment's Shopify app config",
    generate: (_appSettings: YarnScriptSettings) => `shopify app config use shopify.app.toml`,
  },
  "shopify:dev": {
    description: "Start the Shopify CLI dev server using the current development environment's Shopify app config",
    generate: (_appSettings: YarnScriptSettings) =>
      `yarn shopify:deploy:development --force && yarn shopify:config:use:development && shopify app dev --no-update`,
  },
  "shopify:deploy:development": {
    description: "Deploy the development environment; this should be used when developing app extensions to sync the extension to Shopify",
    generate: (_appSettings: YarnScriptSettings) => `yarn shopify:config:use:development && shopify app deploy`,
  },
  "shopify:deploy:production": {
    description:
      "Deploy the production environment; this can be used for CI setups to deploy the app to Shopify after the Gadget app is deployed to production using ggt deploy",
    generate: (_appSettings: YarnScriptSettings) => `yarn shopify:config:use:production && shopify app deploy`,
  },
  "shopify:deploy": {
    description: "An alias for shopify:deploy:production",
    generate: (_appSettings: YarnScriptSettings) => `yarn shopify:deploy:production`,
  },
  "shopify:info": {
    description: "Get info about the Shopify app",
    generate: (_appSettings: YarnScriptSettings) => `shopify app info`,
  },
};
